<template>
  <div>
    <div class="p-2 bg-white border-2 border-b-0 rounded-t gap-2 flex items-center justify-between">
      <div>
        <v-btn @click="toggleSelectAll" elevation="0" class="mr-2">
          {{ $t('select_all') }}
        </v-btn>
        <v-btn
          @click="onPreApproveAll"
          :disabled="selected.length < 1"
          elevation="0"
          color="primary"
        >{{ $t('task.approve_all') }}</v-btn>
      </div>
      <div>
        <v-btn icon elevation="0" color="primary" @click="onInit()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
    </div>
    <template>
      <v-data-table
        show-select
        :headers="headers"
        :items="approveTasks"
        :loading="loading || isLoading"
        :items-per-page="50"
        class="border-2 data-table-resize"
        v-model="selected"
        @toggle-select-all="toggleSelectAll"
        item-key="objectId"
        :no-data-text="$t('booking.no_booking_stall')"
        :no-results-text="$t('no_matching_records_found')"
      >

        <template v-slot:header.customerName="{header}">
          <div class="text-nowrap-table text-center" style="min-width:150px">{{header.text}}</div>
        </template>
        <template v-slot:header.market="{header}">
          <div class="text-nowrap-table text-center" style="min-width:150px">{{header.text}}</div>
        </template>
        <template v-slot:header.areas="{header}">
          <div class="text-nowrap-table text-center" style="min-width:150px">{{header.text}}</div>
        </template>
        <template v-slot:header.productNames="{header}">
          <div class="text-nowrap-table text-center" style="min-width:150px">{{header.text}}</div>
        </template>

        <template v-slot:item.customerName="{ item }">
          <div class="text-truncate">{{ item.getCustomerName || "-" }}</div>
        </template>
        <template v-slot:item.market="{ item }">
          <div class="text-truncate">{{ marketName }}</div>
        </template>
        <template v-slot:item.areas="{ item }">
          <div class="text-truncate">
            {{ item.areaInterest?item.areaInterest.areasString : '' }}
          </div>
        </template>
        <template v-slot:item.productNames="{ item }">
          <div class="text-trancate">
            {{ item.areaInterest?item.areaInterest.productNames.join(", ") : "-" }}
          </div>
        </template>
        <template
          v-slot:item.areasQty="{ item }"
        >{{ item.areaInterest?item.areaInterest.areasQty : "-" }}</template>
        <template  v-slot:item.customerTypeString="{ item }" >
          {{ item.areaInterest?item.areaInterest.customerTypeString : "-" }}
        </template>
        <template v-slot:item.status="{ item }">
          <div class="max-w-sm flex">
            <span :class="item.statusColor + ' px-3 py-1 rounded-full '">
              {{ item.statusString }}
            </span>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="flex justify-end">
            <v-btn
              color="grey lighten-4"
              elevation="0"
              rounded
              small
              @click="onClickEdit(item)"
            >{{ $t('detail') }}</v-btn>
          </div>
        </template>
      </v-data-table>
    </template>
    <template>
      <approve
        v-model="isApprove"
        :interestId="interestId"
        :approveId="approveId"
        :isUpdate="true"
        @onApproveTaskEvent="onInit"
      ></approve>
    </template>
    <ConfirmDialog
      :loading="isLoading"
      v-model="isConfirm"
      :title="`${$t('task.approve')}`"
      :text="`${$t('task.you_want_to_approve_setting', { count: selected.length })}`"
      :isNote="false"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="success"
      @onOk="approveAll" />
  </div>
</template>


<script>
import Approve from "./Approve.vue";
import ConfirmDialog from "./ConfirmDialog.component.vue";
export default {
  components: { Approve, ConfirmDialog },
  data() {
    return {
      isInterest: false,
      interestId: null,
      approveId: null,
      isConfirm: false,
      isApprove: false,
      headers: [
        {
          text: this.$t('name'),
          align: "center hd-resize text-truncate",
          sortable: false,
          value: "customerName",
          width: "1%"
        },
        {
          text: this.$t('market.market_detail'),
          align: "center hd-resize text-truncate",
          sortable: false,
          value: "market",
          width: "1%"
        },
        {
          // ประเภทผู้ค้า
          text: this.$t('customer.customer_type'),
          align: "left",
          value: "customerTypeString",
          width: '110px'
        },
        {
          text: this.$t('area.interested_stall'),
          align: "center",
          sortable: false,
          value: "areasQty",
          width: '130px'
        },
        {
          text: this.$t('product.product_in_sell'),
          align: "center hd-resize text-truncate",
          sortable: false,
          value: "productNames",
          width: "1%"
        },
        {
          text: this.$t('area.stall_number'),
          align: "center hd-resize text-truncate",
          sortable: false,
          value: "areas",
          width: "1%"
        },
        {
          width: "180px",
          text: this.$t('status'),
          align: "center",
          sortable: false,
          value: "status"
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      items: [],
      selected: [],
      isLoading: false
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    marketId() {
      return this.$route.params.marketId;
    },
    marketName() {
      return this.$store.getters["markets/getMarketName"];
    },
    approveTasks() {
      return this.$store.getters["approveTask/getByType"]('area_interest');
    }
  },
  created() {
    //   this.init();
  },
  methods: {
    onPreApproveAll() {
      this.isConfirm = true;
    },
    onClickEdit(object) {
      this.interestId = object.areaInterest.objectId;
      this.approveId = object?.objectId || null;
      this.isApprove = true;
    },
    onInit() {
      this.$emit("onInit");
    },
    afterUpdate(e) {
      this.isInterest = false;
      this.$emit("onInit", true);
      setTimeout(() => {
        this.isInterest = true;
      }, 500);
    },
    toggleSelectAll() {
      if (this.selected.length == this.approveTasks.length) {
        this.selected = [];
      } else {
        this.selected = this.approveTasks;
      }
    },
    async approveAll() {
      try {
        this.isLoading = true;
        // const approve = this.selected.map(async item => {
        //   await this.$store.dispatch("approveTask/approveApproveTask", {
        //     id: item.objectId
        //   });
        // });
        // await Promise.all(approve);
        for (const item of this.selected) {
          await this.$store.dispatch("approveTask/approveApproveTask", {
            id: item.objectId
          });
        }
        this.$toast.show({
          content: this.$t('task.approve_all_success'),
          color: "success"
        });
        this.isConfirm = false;
        this.$emit("onInit", true);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        this.isConfirm = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    }
  }
};
</script>

<style scoped>
.data-table-resize::v-deep td.hd-resize{
  max-width: 150px;
}
.data-table-resize::v-deep td.hd-resize.area-name{
  max-width: 80px;
}
.data-table-resize::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 30px;
    top: 15px;
  }
}
</style>